export default {
  title: 'Vähimmäismaksusumma: Maksut eivät voi olla välillä {{rangeStart}} - {{rangeEnd}}',
  description: 'Poikkeus: Jos sinulla on ilmainen tuote, voit maksaa yhteissummalla {{amount}}.',
};
